import { render, staticRenderFns } from "./DetalleMiProgramaPostgradoPage.vue?vue&type=template&id=2f84b7be&scoped=true&"
import script from "./DetalleMiProgramaPostgradoPage.js?vue&type=script&lang=js&"
export * from "./DetalleMiProgramaPostgradoPage.js?vue&type=script&lang=js&"
import style0 from "./DetalleMiProgramaPostgradoPage.vue?vue&type=style&index=0&id=2f84b7be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84b7be",
  null
  
)

export default component.exports